import { Backdrop, CircularProgress } from "@mui/material";

export const LazyLoading = () => {
	return <div>Loading Please Wait..</div>;
};

export const CenteredLazyLoading = ({
	minHeight = 300,
}: {
	minHeight?: number;
}) => {
	return (
		<div
			style={{
				display: "flex",
				minHeight: minHeight,
				justifyContent: "center",
				alignItems: "center",
				height: "100%",
				width: "100%",
			}}
		>
			<CircularProgress />
		</div>
	);
};

type LazyBackDropLoadingProps = {
	open: boolean;
};
export const LazyBackDropLoading = (props: LazyBackDropLoadingProps) => {
	return (
		<Backdrop open={props.open} style={{ color: "#fff", zIndex: 100000 }}>
			<CircularProgress color="inherit" />
		</Backdrop>
	);
};
